<div class="date-time-container">
  <input type="date" name="date" class="form-control date" [(ngModel)]="date" (ngModelChange)="onChangeValue()"
         [required]="required" [disabled]="disabled">
  <input type="time" name="time" step="1" class="form-control time" [(ngModel)]="time" (ngModelChange)="onChangeValue()"
         [required]="required" [disabled]="disabled">
</div>
